const translations = {
  "en": {
    "TTM": "TTM"
  },
  "zh-tw": {
    "TTM": "TTM"
  }
};

export default translations;
